module.exports = __webpack_public_path__ + "static/media/ico-loupe.5a20f19b.svg";